"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-two/sections/workSection.tsx */

import { SmartImage } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type WorkSection6sItem = {
    key: Key | null | undefined;
    /** Detected variants: "search doctor" | "profile" | "booking" | "your solution" */
    alt: string;
    /** Detected variants: "/Templates/Doccure/img/icons/search.svg" | "/Templates/Doccure/img/icons/profile.svg" | "/Templates/Doccure/img/icons/schedule.svg" | "/Templates/Doccure/img/icons/solution.svg" */
    src: string;
    /** Detected variants: "Search Doctor" | "Check Profile" | "Schedule Boooking" | "Get Your Solution" */
    h30Text: ReactNode;
    /** Detected variants: "Search for a doctor based on specialization, location, or availability." | "Explore detailed doctor profiles on our platform to make informed healthcare." | "After choose your preferred doctor, select a convenient time slot, & confirm." */
    p0Text: ReactNode;
    /** Detected variants: "col-md-6 d-flex" */
    className?: string;
    /** Detected variants: "work-item w-100 wow fadeInUp" */
    div0ClassName?: string;
    /** Detected variants: "0.2s" */
    dataWowDelay?: string;
    /** Detected variants: "1s" */
    dataWowDuration?: string;
    /** Detected variants: "work-icon" */
    div0ClassName2?: string;
    /** Detected variants: "custom-title" */
    h30ClassName?: string;
};
export type HomeTwoWorkSectionGeneratedProps = {
    divDiv0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: WorkSection6sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    divDiv0Div1H30H3Props?: Partial<ComponentProps<"h3">> | ((item: WorkSection6sItem) => Partial<ComponentProps<"h3">>);
    sectionDiv0Div0ClassName?: string;
    /** Default: "work" */
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/about/about-01.png" */
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageSrc?: string;
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "0.2s" */
    sectionDiv0Div0Div1DivDataWowDelay?: string;
    /** Default: "1s" */
    sectionDiv0Div0Div1DivDataWowDuration?: string;
    /** Default: "How it Works" */
    sectionDiv0Div0Div1Div0Div0DivText?: ReactNode;
    /** Default: "icon" */
    sectionDiv0Div0Div1Div0Div0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/icons/section-icon.svg" */
    sectionDiv0Div0Div1Div0Div0ImageWithBasePath0ImageSrc?: string;
    sectionDiv0Div0Div1Div0Div0ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0Div0Div1Div0Div0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div1Div0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "4 Easy Steps to" */
    sectionDiv0Div0Div1Div0H20H2Text?: ReactNode;
    sectionDiv0Div0Div1Div0H20H2Visible?: boolean;
    sectionDiv0Div0Div1Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div1Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "Get Your Solution" */
    sectionDiv0Div0Div1Div0H20Span0SpanText?: ReactNode;
    sectionDiv0Div0Div1Div1ClassName?: string;
    /** Default: "bg" */
    sectionImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/about-bg.png" */
    sectionImageWithBasePath0ImageSrc?: string;
    sectionImageWithBasePath0ImageVisible?: boolean;
    sectionImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "bg" */
    sectionImageWithBasePath1ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/work-bg.png" */
    sectionImageWithBasePath1ImageSrc?: string;
    sectionImageWithBasePath1ImageVisible?: boolean;
    sectionImageWithBasePath1ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath1ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "bg" */
    sectionImageWithBasePath2ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/work-bg-01.png" */
    sectionImageWithBasePath2ImageSrc?: string;
    sectionImageWithBasePath2ImageVisible?: boolean;
    sectionImageWithBasePath2ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath2ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "bg" */
    sectionImageWithBasePath3ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/work-bg-02.png" */
    sectionImageWithBasePath3ImageSrc?: string;
    sectionImageWithBasePath3ImageVisible?: boolean;
    sectionImageWithBasePath3ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath3ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    workSection6s: WorkSection6sItem[];
    workSection6sItemWrapper?: (item: WorkSection6sItem, content: ReactNode) => ReactNode;
    workSection6sRenderer?: (defaultNode: ReactNode) => ReactNode;
    workSection6sImageVisible?: boolean;
    workSection6sImageRenderer?: (item: WorkSection6sItem, defaultNode: ReactNode) => ReactNode;
    workSection6sH3Visible?: boolean;
    workSection6sH3Renderer?: (item: WorkSection6sItem, defaultNode: ReactNode) => ReactNode;
    workSection6sImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: WorkSection6sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    workSection6sH3Props?: Partial<ComponentProps<"h3">> | ((item: WorkSection6sItem) => Partial<ComponentProps<"h3">>);
};

const HomeTwoWorkSectionGenerated: FC<HomeTwoWorkSectionGeneratedProps> = ({
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageAlt = "work",
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/about/about-01.png",
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageVisible,
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageRenderer,
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageProps,
    sectionDiv0Div0Div1Div0Div0DivText = "How it Works",
    sectionDiv0Div0Div1Div0Div0ImageWithBasePath0ImageAlt = "icon",
    sectionDiv0Div0Div1Div0Div0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/icons/section-icon.svg",
    sectionDiv0Div0Div1Div0Div0ImageWithBasePath0ImageVisible,
    sectionDiv0Div0Div1Div0Div0ImageWithBasePath0ImageRenderer,
    sectionDiv0Div0Div1Div0Div0ImageWithBasePath0ImageProps,
    sectionDiv0Div0Div1Div0H20H2Text = "4 Easy Steps to",
    sectionDiv0Div0Div1Div0H20H2Visible,
    sectionDiv0Div0Div1Div0H20H2Renderer,
    sectionDiv0Div0Div1Div0H20H2Props,
    sectionDiv0Div0Div1Div0H20Span0SpanText = "Get Your Solution",
    sectionDiv0Div0Div1DivDataWowDelay = "0.2s",
    sectionDiv0Div0Div1DivDataWowDuration = "1s",
    sectionImageWithBasePath0ImageAlt = "bg",
    sectionImageWithBasePath0ImageSrc = "/Templates/Doccure/img/bg/about-bg.png",
    sectionImageWithBasePath0ImageVisible,
    sectionImageWithBasePath0ImageRenderer,
    sectionImageWithBasePath0ImageProps,
    sectionImageWithBasePath1ImageAlt = "bg",
    sectionImageWithBasePath1ImageSrc = "/Templates/Doccure/img/bg/work-bg.png",
    sectionImageWithBasePath1ImageVisible,
    sectionImageWithBasePath1ImageRenderer,
    sectionImageWithBasePath1ImageProps,
    sectionImageWithBasePath2ImageAlt = "bg",
    sectionImageWithBasePath2ImageSrc = "/Templates/Doccure/img/bg/work-bg-01.png",
    sectionImageWithBasePath2ImageVisible,
    sectionImageWithBasePath2ImageRenderer,
    sectionImageWithBasePath2ImageProps,
    sectionImageWithBasePath3ImageAlt = "bg",
    sectionImageWithBasePath3ImageSrc = "/Templates/Doccure/img/bg/work-bg-02.png",
    sectionImageWithBasePath3ImageVisible,
    sectionImageWithBasePath3ImageRenderer,
    sectionImageWithBasePath3ImageProps,
    divDiv0Div0ImageWithBasePath0ImageProps,
    divDiv0Div1H30H3Props,
    sectionDiv0Div0ClassName,
    sectionDiv0Div0Div1Div1ClassName,
    workSection6s,
    workSection6sItemWrapper,
    workSection6sRenderer,
    workSection6sImageVisible,
    workSection6sImageRenderer,
    workSection6sH3Visible,
    workSection6sH3Renderer,
    workSection6sImageProps,
    workSection6sH3Props,
}) => {
    return (
        <section className="section work-section-two">
            <div className="container">
                <div className={sectionDiv0Div0ClassName ?? "row"}>
                    <div className="col-xl-5">
                        <div className="work-img-two">
                            {renderNode(sectionDiv0Div0Div0Div0ImageWithBasePath0ImageVisible, sectionDiv0Div0Div0Div0ImageWithBasePath0ImageRenderer, (
                                <SmartImage src={sectionDiv0Div0Div0Div0ImageWithBasePath0ImageSrc} alt={sectionDiv0Div0Div0Div0ImageWithBasePath0ImageAlt} className="img-fluid" {...(sectionDiv0Div0Div0Div0ImageWithBasePath0ImageProps ?? {})} />
                            ))}
                        </div>
                    </div>
                    <div className="col-xl-7 wow fadeInUp" data-wow-delay={sectionDiv0Div0Div1DivDataWowDelay} data-wow-duration={sectionDiv0Div0Div1DivDataWowDuration}>
                        <div className="section-header section-header-two text-start">
                            <div className="section-sub-title">
                                {renderNode(sectionDiv0Div0Div1Div0Div0ImageWithBasePath0ImageVisible, sectionDiv0Div0Div1Div0Div0ImageWithBasePath0ImageRenderer, (
                                    <SmartImage src={sectionDiv0Div0Div1Div0Div0ImageWithBasePath0ImageSrc} alt={sectionDiv0Div0Div1Div0Div0ImageWithBasePath0ImageAlt} {...(sectionDiv0Div0Div1Div0Div0ImageWithBasePath0ImageProps ?? {})} />
                                ))}
                                {sectionDiv0Div0Div1Div0Div0DivText}
                            </div>
                            {renderNode(sectionDiv0Div0Div1Div0H20H2Visible, sectionDiv0Div0Div1Div0H20H2Renderer, (
                                <h2 className="section-title mb-0" {...(sectionDiv0Div0Div1Div0H20H2Props ?? {})}>
                                    {sectionDiv0Div0Div1Div0H20H2Text}
                                    <span>{sectionDiv0Div0Div1Div0H20Span0SpanText}</span>
                                </h2>
                            ))}
                        </div>
                        <div className={sectionDiv0Div0Div1Div1ClassName ?? "row g-4"}>
                            {renderCollectionNode(
                                workSection6s,
                                (item: WorkSection6sItem) => (
                                    <div className={item.className ?? "col-md-6 d-flex"} key={item.key}>
                                        <div className={item.div0ClassName ?? "work-item w-100 wow fadeInUp"} data-wow-delay={item.dataWowDelay ?? "0.2s"} data-wow-duration={item.dataWowDuration ?? "1s"}>
                                            <div className={item.div0ClassName2 ?? "work-icon"}>
                                                {renderItemNode(workSection6sImageVisible, workSection6sImageRenderer, item, (
                                                    <SmartImage src={item.src} alt={item.alt} {...(typeof workSection6sImageProps === "function" ? workSection6sImageProps(item) : (workSection6sImageProps ?? {}))} {...(typeof divDiv0Div0ImageWithBasePath0ImageProps === "function" ? divDiv0Div0ImageWithBasePath0ImageProps(item) : (divDiv0Div0ImageWithBasePath0ImageProps ?? {}))} />
                                                ))}
                                            </div>
                                            <div>
                                                {renderItemNode(workSection6sH3Visible, workSection6sH3Renderer, item, (
                                                    <h3 className={item.h30ClassName ?? "custom-title"} {...(typeof workSection6sH3Props === "function" ? workSection6sH3Props(item) : (workSection6sH3Props ?? {}))} {...(typeof divDiv0Div1H30H3Props === "function" ? divDiv0Div1H30H3Props(item) : (divDiv0Div1H30H3Props ?? {}))}>{item.h30Text}</h3>
                                                ))}
                                                <p>
                                                    {item.p0Text}
                                                    {" "}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                ),
                                workSection6sItemWrapper,
                                workSection6sRenderer
                            )}
                        </div>
                    </div>
                </div>
            </div>
            {renderNode(sectionImageWithBasePath0ImageVisible, sectionImageWithBasePath0ImageRenderer, (
                <SmartImage src={sectionImageWithBasePath0ImageSrc} alt={sectionImageWithBasePath0ImageAlt} className="img-fluid work-bg-01" {...(sectionImageWithBasePath0ImageProps ?? {})} />
            ))}
            {renderNode(sectionImageWithBasePath1ImageVisible, sectionImageWithBasePath1ImageRenderer, (
                <SmartImage src={sectionImageWithBasePath1ImageSrc} alt={sectionImageWithBasePath1ImageAlt} className="work-bg-02" {...(sectionImageWithBasePath1ImageProps ?? {})} />
            ))}
            {renderNode(sectionImageWithBasePath2ImageVisible, sectionImageWithBasePath2ImageRenderer, (
                <SmartImage src={sectionImageWithBasePath2ImageSrc} alt={sectionImageWithBasePath2ImageAlt} className="work-bg-03" {...(sectionImageWithBasePath2ImageProps ?? {})} />
            ))}
            {renderNode(sectionImageWithBasePath3ImageVisible, sectionImageWithBasePath3ImageRenderer, (
                <SmartImage src={sectionImageWithBasePath3ImageSrc} alt={sectionImageWithBasePath3ImageAlt} className="work-bg-04" {...(sectionImageWithBasePath3ImageProps ?? {})} />
            ))}
        </section>
    );
};

export default HomeTwoWorkSectionGenerated;
